/**
 * Applications Hooks
 *
 * Hooks for fetching storm applications from the API.
 */

import { useQuery } from "@tanstack/react-query";
import { applicationsApi } from "@/api";

/**
 * Fetch all storm applications for the current organization
 */
export function useApplications() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["applications", "list"],
    queryFn: () => applicationsApi.list(),
  });

  return { data: data ?? null, loading: isLoading, error, refetch };
}

/**
 * Get only displayable applications (where display=true)
 */
export function useDisplayableApplications() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["applications", "list"],
    queryFn: () => applicationsApi.list(),
    select: (data) => data.filter((app) => app.display),
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error,
    refetch,
  };
}
